<template>
  <div class="stop-label">
    <DropOffIcon v-if="stop.isDropOff" />
    <PickupIcon v-if="stop.isPickup" />
    <span v-if="stop.sequenceNumber" class="sequence-number">
      {{
        t('common.paramNum', {
          param: t('shipments.stops'),
          num: stop.sequenceNumber,
        })
      }}
    </span>
    <span v-if="stopName" class="stop-name">
      {{ stopName }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { ShipmentStop, ShippingPoint } from '@/model';

import DropOffIcon from '@/components/shippingPoint/DropoffIcon.vue';
import PickupIcon from '@/components/shippingPoint/PickupIcon.vue';

const props = defineProps({
  stop: {
    type: Object as PropType<ShippingPoint>,
    default: () => new ShipmentStop(),
  },
});
const { stop } = toRefs(props);

const { t } = useI18n();

const stopName = computed(() => {
  return [
    stop.value.location?.locationName,
    stop.value.location?.city,
    stop.value.location?.state,
  ]
    .filter((x) => !!x?.trim())
    .join(', ');
});
</script>

<style>
.stop-label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  .sequence-number {
    padding-left: var(--sp-1);
  }

  .stop-name {
    &::before {
      content: ' - ';
    }
  }
}
</style>
